
import { useState, useEffect } from "react";
import { VouchersList } from "./VouchersList";
import { ClaimForm } from "./ClaimForm";
import { VoucherModal } from "./VoucherModal";
import { Voucher } from "@/types/voucher";
import { useUserVouchers } from "@/hooks/useUserVouchers";

export function VoucherContainer() {
  const { vouchers, loading, fetchVouchers, claimVoucher } = useUserVouchers();
  const [selectedVoucher, setSelectedVoucher] = useState<Voucher | null>(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    fetchVouchers();
  }, []);

  const handleVoucherSelect = (voucher: Voucher) => {
    setSelectedVoucher(voucher);
    setModalOpen(true);
  };

  const handleClaimVoucher = async (code: string) => {
    await claimVoucher(code);
  };

  return (
    <>
      <main className="flex-1 flex flex-col p-4 max-w-md mx-auto w-full">
        <section className="flex-1 overflow-y-auto mb-4">
          <h2 className="text-xl font-bold mb-4">Your Vouchers</h2>
          <VouchersList 
            vouchers={vouchers} 
            onVoucherSelect={handleVoucherSelect}
            isLoading={loading}
          />
        </section>
        
        <section className="mt-auto pt-4 border-t border-gray-800">
          <ClaimForm onSubmit={handleClaimVoucher} isLoading={loading} />
        </section>
      </main>

      {selectedVoucher && (
        <VoucherModal
          voucher={selectedVoucher}
          open={modalOpen}
          onOpenChange={setModalOpen}
        />
      )}
    </>
  );
}
